module.exports = __webpack_public_path__ + "static/media/page-first.87b11e60.svg";